import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiPost } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const pagePost = createAsyncThunk(
	"page/post",
	apiPost((authConfig) => authConfig.PAGE_API_ENDPOINTS_TOP_URL.PAGE(), [SCOPES.FUNCTION_WRITE]),
);
